import "./App.css";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import Welcome from "./spaces/Welcome";
import Today from "./spaces/Today";
import Rhythm from "./spaces/Rhythm";
import Pray from "./spaces/Pray";
import Evening from "./spaces/Evening";
import Login from "./spaces/Login";
import History from "./spaces/History";
import Register from "./spaces/Register";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

function Navigation({ user, onLogout }) {

  const spaces = [
    { path: "/today", label: "Today" },
    { path: "/pray", label: "Pray" },
    { path: "/rhythm", label: "Rhythm" },
    { path: "/evening", label: "Evening" },
    { path: "/history", label: "History" }
  ];

  return (
    <>
      {/* Desktop Navigation */}

      <nav className="navigation">

        {spaces.map(space => (

          <NavLink
            key={space.path}
            to={space.path}
            className={({ isActive }) =>
              `nav-link ${isActive ? "nav-link-active" : ""}`
            }
          >
            {space.label}
          </NavLink>

        ))}

        <div style={{ marginLeft: "40px", fontSize: "14px" }}>

          {user ? (
            <>
              Logged in as {user.email}

              <button
                onClick={onLogout}
                style={{
                  marginLeft: "10px",
                  padding: "4px 8px",
                  cursor: "pointer"
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <NavLink
                to="/login"
                className="nav-link"
              >
                Login
              </NavLink>
            </>
          )}

        </div>

      </nav>

      {/* Mobile Bottom Navigation */}

      <nav className="bottom-nav">

        <NavLink to="/today">Today</NavLink>
        <NavLink to="/pray">Pray</NavLink>
        <NavLink to="/rhythm">Rhythm</NavLink>
        <NavLink to="/evening">Evening</NavLink>
        <NavLink to="/history">History</NavLink>

        {user ? (
          <button
            onClick={onLogout}
            style={{
              background: "none",
              border: "none",
              color: "#8a8685",
              fontFamily: "Cormorant Garamond, Georgia, serif"
            }}
          >
            Logout
          </button>
        ) : (
          <NavLink to="/login">Login</NavLink>
        )}

      </nav>

    </>
  );

}

function Layout({ children, user, logout }) {

  const location = useLocation();

  const hideNavigation =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/register";

  return (
    <>
      {!hideNavigation && <Navigation user={user} onLogout={logout} />}
      {children}
    </>
  );
}

export default function App() {

  const [user, setUser] = useState(null);

  function loadUser(){

    const token = localStorage.getItem("token");

    if(!token){
      setUser(null);
      return;
    }

    fetch(API+"/me",{
      headers:{
        Authorization:"Bearer "+token
      }
    })
    .then(res=>{

      if(!res.ok){
        localStorage.removeItem("token");
        setUser(null);
        return null;
      }

      return res.json();

    })
    .then(data=>{
      if(data){
        setUser(data);
      }
    })
    .catch(()=>{
      setUser(null);
    });

  }

  useEffect(()=>{
    loadUser();
  },[]);

  function logout(){

    localStorage.removeItem("token");
    setUser(null);
    window.location="/login";

  }

  return (

    <BrowserRouter>

      <Layout user={user} logout={logout}>

        <Routes>

          <Route path="/" element={<Welcome />} />

          <Route path="/today" element={<Today />} />
          <Route path="/pray" element={<Pray />} />
          <Route path="/rhythm" element={<Rhythm />} />
          <Route path="/evening" element={<Evening />} />
          <Route path="/history" element={<History />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

        </Routes>

      </Layout>

    </BrowserRouter>

  );

}
